import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/contexts/auth-context';
import { UserRole } from '@/api-models/UserRole';

export function AdminGuard() {
  const { me } = useAuth();
  if (me?.role !== UserRole.Admin) {
    return <Navigate to="/app" replace />;
  }
  return <Outlet />;
}
